import { useEffect } from "react";
import Config from "../Config";
import { apis } from "../services/apiService";
import { useNavigate } from "react-router";
import { loggerStore } from "./utils";
import configData from "../Config";

const usePluralPay = () => {
  const navigate = useNavigate();
  useEffect(() => {
    function loadScript() {
      return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src =
          "https://checkout-staging.pluralonline.com/v1/web-sdk-checkout.js";
        script.onload = () => {
          resolve(true);
        };
        script.onerror = () => {
          alert("Plural failed to load. Please try after sometime");
          resolve(false);
        };
        document.body.appendChild(script);
      });
    }
    loadScript();
  }, []);

  const pluralcreateOrder = async (data, setLoading, URL, screen = "") => {
    try {
      // const res = await apis.postApi(URL, data);
      // const res =
      //   screen === "Repayement"
      //     ? await apis.postApiWithCustomHeader(URL, data, {
      //         Authorization: `Basic VkxFX0FkYW5pOkFkYW5pQDE=`,
      //       })
      //     : await apis.postApi(URL, data);
      const res = await apis.postApi(URL, data);
      const resData = await res.json();
      // console.log("resData--data--", resData);
      //console.log("resData--data--", typeof resData);
      loggerStore(
        screen === "Repayement" ? data?.vleId : data?.aid,
        `plural pay order created for ${screen} = ${JSON.stringify(resData)}`,
        "Information"
      );
      // console.log("Create order API called", resData);
      if (resData.successResult === null) {
        alert(resData?.failedResult?.error_message);
        setLoading(false);
        return resData;
      } else {
        setLoading(false);
        return resData;
      }
    } catch (err) {
      //console.log("createOrder err--", err);
      let errorMsg = JSON?.parse(err?.message);
      setLoading(false);
      loggerStore(
        screen === "Repayement" ? data?.vleId : data?.aid,
        `plural pay order created catch error for ${screen} = ${JSON.stringify(
          errorMsg
        )}`,
        "Error"
      );
    }
  };

  const openPlural = async (
    createOrderResponse,
    setLoading,
    setPaymentStatus,
    setEMsg,
    screen = "",
    setRadioVal = () => {}
  ) => {
    const commanAPIRequest = {
      // app_Number: createOrderResponse?.appID || "",
      mobile: createOrderResponse?.mobileNumber || "",
      amount: createOrderResponse?.amount || "",
      tokensurl: createOrderResponse?.orderToken || "",
      arNumber: createOrderResponse?.arNumber || "",
      merchant_order_id: createOrderResponse?.merchant_order_id || "",
    };
    if (screen === "PFPayment") {
      commanAPIRequest.app_Number = createOrderResponse?.appID || "";
    } else {
      commanAPIRequest.type = createOrderResponse?.type;
      commanAPIRequest.vleId = createOrderResponse?.vleId || "";
    }
    // const commanAPIRequestForRP = {
    //   type: createOrderResponse?.type,
    //   uId: 0,
    //   vleId: createOrderResponse?.vleId || "",
    //   mobile: createOrderResponse?.mobileNumber || "",
    //   amount: createOrderResponse?.amount || "",
    //   tokensurl: createOrderResponse?.orderToken || "",
    //   arNumber: createOrderResponse?.arNumber || "",
    //   merchant_order_id: createOrderResponse?.merchant_order_id || "",
    // };

    const options = {
      theme: createOrderResponse?.theme, // "default" or "black"
      orderToken: createOrderResponse?.orderToken,
      channelId: createOrderResponse?.channelId, // "APP" or "WEB"
      paymentMode: createOrderResponse?.paymentMode, // comma separated - Example - 'CREDIT_DEBIT,NETBANKING,UPI,WALLET,EMI,DEBIT_EMI'
      countryCode: createOrderResponse?.countryCode, // type = string, default "91"
      mobileNumber: createOrderResponse?.mobileNumber, // type = string, default = null
      emailId: createOrderResponse?.emailId, //default null
      showSavedCardsFeature: createOrderResponse?.showSavedCardsFeature, // type = boolean, default = true

      // success response handler start from here
      successHandler: async function (response) {
        // Handle success response
        setLoading(false);
        loggerStore(
          response?.payment_id,
          `plural pay Payment success status for ${screen} & payment ID:- ${
            createOrderResponse?.orderToken
          } = ${JSON.stringify(response)}`,
          "Success"
        );
        // console.log("success handler", response);
        try {
          setLoading(true);
          const reqData = {
            ...commanAPIRequest,
            plural_Payment_Status: true,
            plural_Payment_Id: response?.payment_id?.toString() || "",
            plural_Order_Order_Id: response?.plural_order_id?.toString() || "",
            plural_Error_Code: response?.error_code || "",
            plural_Error_Message: response?.error_message || "",
          };
          const API =
            screen === "PFPayment"
              ? `${configData?.PFPayemntUrl}PluralPayment/CheckPaymentStatus`
              : `${configData?.RepaymentUrl}PluralPayment/CheckPaymentStatus`;
          const res = await apis.postApi(`${API}`, reqData);
          let result = await res.json();
          if (res?.status === 200) {
            setLoading(false);
            loggerStore(
              createOrderResponse?.appID,
              `plural pay status inquiry API called sucessfully for ${
                createOrderResponse?.appID
              } = ${JSON.stringify(res)}`,
              "Success"
            );
          }
        } catch (error) {
          // console.log(error);
          let errorMsg = JSON?.parse(error?.message);
          loggerStore(
            response?.payment_id,
            `plural pay status inquiry API called failed for ${screen} = ${JSON.stringify(
              errorMsg
            )}`,
            "Error"
          );
        }
        setEMsg("");
        setRadioVal("");
        setPaymentStatus({
          ...response,
          ["status"]: "Paid",
          ["arNumber"]: createOrderResponse?.arNumber,
        });
      },
      // success response handler ended here

      // failure response handler start from here
      failedHandler: async function (response) {
        // Handle failure response
        setLoading(false);
        loggerStore(
          response?.payment_id,
          `Payment failed status for ${
            createOrderResponse?.orderToken
          } = ${JSON.stringify(response)}`,
          "Failed"
        );
        // console.log("failure handler", response);
        try {
          const reqData = {
            ...commanAPIRequest,
            plural_Payment_Status: false,
            plural_Payment_Id: response?.payment_id?.toString() || "",
            plural_Order_Order_Id: createOrderResponse?.cOPluralOrderID,
            plural_Error_Code: response?.error_code || "",
            plural_Error_Message: response?.error_message || "",
          };
          // console.log("request for failed----", reqData);
          const API =
            screen === "PFPayment"
              ? `${configData?.PFPayemntUrl}PluralPayment/CheckPaymentStatus`
              : `${configData?.RepaymentUrl}PluralPayment/CheckPaymentStatus`;
          const res = await apis.postApi(`${API}`, reqData);
          let result = await res.json();
          if (res?.status === 200) {
            loggerStore(
              createOrderResponse?.appID,
              `plural pay status inquiry API called failed for ${screen} = ${JSON.stringify(
                res
              )}`,
              "Error"
            );
          }
        } catch (error) {
          // console.log(error);
          let errorMsg = JSON?.parse(error?.message);
          loggerStore(
            response?.payment_id,
            `plural pay status inquiry API called failed for ${screen} = ${JSON.stringify(
              errorMsg
            )}`,
            "Error"
          );
        }
        setEMsg("Transaction is failed kindly retry again");
        setRadioVal("");
        setPaymentStatus({
          ...response,
          ["status"]: "Failed",
          ["arNumber"]: createOrderResponse?.arNumber,
        });
      },
      // failure response handler ended from here
    };
    // console.log("Open Plural UI");
    const plural = new window.Plural(options);
    plural.open(options);
  };
  return {
    pluralcreateOrder,
    openPlural,
  };
};

export default usePluralPay;
